var render = function render(){
  var _vm$clientData, _vm$clientData$client, _vm$clientData2, _vm$clientData2$clien;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form d-flex",
    "class": {
      'popup-manager': _vm.clientFlowData
    }
  }, [_vm.clientFlowData ? _c('div', {
    staticClass: "w-50 taskList white client-flow-panel"
  }, [_c('div', {
    staticClass: "client-flow-heading"
  }, [_vm._m(0), _c('div', {
    staticClass: "client-flow-count"
  }, [_vm._v(_vm._s(_vm.flowCompletedCount) + "/" + _vm._s(_vm.clientFlowChoices.length))])]), _c('div', {
    staticClass: "client-flow-progress",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    style: {
      width: _vm.flowProgressWidth
    }
  })]), _c('div', {
    staticClass: "client-flow-list"
  }, _vm._l(_vm.clientFlowChoices, function (option, index) {
    return _c('button', {
      key: option.value,
      staticClass: "client-flow-task",
      "class": _vm.flowTaskState(index),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleClientFlowOption(option.value);
        }
      }
    }, [_c('span', {
      staticClass: "client-flow-marker"
    }, [index <= _vm.currentFlowIndex ? _c('span', [_vm._v("✓")]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _c('span', {
      staticClass: "client-flow-copy"
    }, [_c('strong', [_vm._v(_vm._s(option.display_name))]), _c('small', [_vm._v(_vm._s(_vm.flowTaskHint(index)))])])]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "content-form-popup",
    "class": {
      'w-50': _vm.clientFlowData
    }
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('button', {
    staticClass: "back-button-wrapper pointer",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť údaje klienta"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1)]), _vm.loading ? _c('div', {
    staticClass: "client-load-state",
    attrs: {
      "role": "status"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 24
    }
  }), _c('span', [_vm._v("Načítavam údaje klienta…")])], 1) : _vm.loadError ? _c('div', {
    staticClass: "client-load-state",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loadError))]), _c('button', {
    staticClass: "client-consultation-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadClient
    }
  }, [_vm._v("Skúsiť znova")])]) : _vm.clientLoaded ? [_c('div', {
    staticClass: "payload-name-block"
  }, [_c('div', {
    staticClass: "client-name-block justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "alt": "",
      "loading": "lazy",
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
    }
  }), _c('div', {
    staticClass: "div-block-28"
  }, [_c('div', {
    staticClass: "light-text lightgrey"
  }, [_vm._v(" " + _vm._s(_vm.clientData.email.includes("@nomail.bankari.sk") ? 'Neregistrovaný klient' : 'Klient') + " ")]), _c('div', {
    staticClass: "dark-blue-cta-text"
  }, [_c('div', {
    staticClass: "blc-color"
  }, [_vm._v(" " + _vm._s(_vm.constructClientLabel()) + " ")])])])]), _c('client-personal-info-handler', {
    attrs: {
      "client-info": _vm.getClientInfo(),
      "client-profile": _vm.clientData.client_profile,
      "rules": ['single'],
      "icon-button": ""
    }
  })], 1)]), _c('div', {
    staticClass: "email-cta"
  }, [_c('app-icon', {
    staticClass: "contact-icon",
    attrs: {
      "name": "mail",
      "size": 22
    }
  }), _c('div', {
    staticClass: "cta-email"
  }, [_c('div', {
    staticClass: "light-text lightgrey"
  }, [_vm._v("Email")]), _c('a', {
    staticClass: "blc-color pointer",
    attrs: {
      "href": "mailto:".concat(_vm.clientData.email.includes('@nomail.bankari.sk') ? '' : _vm.clientData.email),
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.clientData.email.includes("@nomail.bankari.sk") ? "" : _vm.clientData.email) + " ")])])], 1), _c('button', {
    staticClass: "client-consultation-cta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openConsultation
    }
  }, [_c('span', {
    staticClass: "client-consultation-cta__icon"
  }, [_c('app-icon', {
    attrs: {
      "name": "calendar",
      "size": 28
    }
  })], 1), _vm._m(1), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("›")])]), _c('div', {
    staticClass: "email-cta"
  }, [_c('app-icon', {
    staticClass: "contact-icon",
    attrs: {
      "name": "phone",
      "size": 22
    }
  }), _c('div', {
    staticClass: "cta-email"
  }, [_c('div', {
    staticClass: "light-text lightgrey"
  }, [_vm._v("Telefón")]), _c('div', {
    staticClass: "blc-color"
  }, [_c('a', {
    staticClass: "blc-color pointer",
    attrs: {
      "href": "tel:".concat((_vm$clientData = _vm.clientData) === null || _vm$clientData === void 0 ? void 0 : (_vm$clientData$client = _vm$clientData.client_profile) === null || _vm$clientData$client === void 0 ? void 0 : _vm$clientData$client.telephone),
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s((_vm$clientData2 = _vm.clientData) === null || _vm$clientData2 === void 0 ? void 0 : (_vm$clientData2$clien = _vm$clientData2.client_profile) === null || _vm$clientData2$clien === void 0 ? void 0 : _vm$clientData2$clien.telephone) + " ")])])])], 1), _c('div', {
    staticClass: "popup-block d-flex flex-column status-list"
  }, [_c('div', {
    staticClass: "status-option d-flex justify-content-start pointer",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'rozpracovaný'
    },
    on: {
      "click": function click($event) {
        return _vm.setClientObStatus('rozpracovaný');
      }
    }
  }, [_c('div', {
    staticClass: "checkboxWrapper",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'rozpracovaný'
    }
  }, [_vm.clientData.client_profile.ob_status === 'rozpracovaný' ? _c('app-icon', {
    attrs: {
      "name": "check",
      "size": 15
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "cta-email"
  }, [_vm._v(" rozpracovaný ")])]), _c('div', {
    staticClass: "status-option d-flex justify-content-start pointer",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'cakacka'
    },
    on: {
      "click": function click($event) {
        return _vm.setClientObStatus('cakacka');
      }
    }
  }, [_c('div', {
    staticClass: "checkboxWrapper",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'cakacka'
    }
  }, [_vm.clientData.client_profile.ob_status === 'cakacka' ? _c('app-icon', {
    attrs: {
      "name": "check",
      "size": 15
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "cta-email"
  }, [_vm._v(" čakačka ")])]), _c('div', {
    staticClass: "status-option d-flex justify-content-start pointer",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'servis'
    },
    on: {
      "click": function click($event) {
        return _vm.setClientObStatus('servis');
      }
    }
  }, [_c('div', {
    staticClass: "checkboxWrapper",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'servis'
    }
  }, [_vm.clientData.client_profile.ob_status === 'servis' ? _c('app-icon', {
    attrs: {
      "name": "check",
      "size": 15
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "cta-email"
  }, [_vm._v(" servis ")])]), _c('div', {
    staticClass: "status-option d-flex justify-content-start pointer",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'archivovany'
    },
    on: {
      "click": function click($event) {
        return _vm.archiveClient(null, true);
      }
    }
  }, [_c('div', {
    staticClass: "checkboxWrapper",
    "class": {
      'is-selected': _vm.clientData.client_profile.ob_status === 'archivovany'
    }
  }, [_vm.clientData.client_profile.ob_status === 'archivovany' ? _c('app-icon', {
    attrs: {
      "name": "check",
      "size": 15
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "cta-email"
  }, [_vm._v(" archív ")])])]), _c('button', {
    staticClass: "quick-processed-deal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openQuickProcessedMortgage
    }
  }, [_c('span', {
    staticClass: "quick-processed-deal__icon"
  }, [_vm._v("✓")]), _vm._m(2), _c('span', {
    staticClass: "quick-processed-deal__arrow"
  }, [_vm._v("›")])]), _c('div', {
    staticClass: "primary d-flex justify-content-between popupSection"
  }, [_c('span', {
    staticClass: "text-small bl-color pointer"
  }, [_vm._v("HYPOTÉKY KLIENTA")]), _c('span', {
    on: {
      "click": _vm.createMortgage
    }
  }, [_vm._v("+ pridať")])]), _vm._l(_vm.clientData.mortgages, function (mortgage) {
    return _c('div', {
      key: mortgage.id,
      staticClass: "popup-block div-block-101 pointer client-mortgage",
      "class": {
        'is-current-mortgage': _vm.currentMortgageId === Number(mortgage.id)
      },
      attrs: {
        "aria-current": _vm.currentMortgageId === Number(mortgage.id) ? 'page' : null
      },
      on: {
        "click": function click($event) {
          return _vm.openMortgage(mortgage.id);
        }
      }
    }, [_c('div', {
      staticClass: "wrap"
    }, [_c('div', {
      staticClass: "primary client-mortgage__title"
    }, [_vm._v(" " + _vm._s(_vm.getChoicesFromFormByKey("hlavny_ucel", mortgage.hlavny_ucel)) + " "), _vm.currentMortgageId === Number(mortgage.id) ? _c('span', {
      staticClass: "client-mortgage__current"
    }, [_vm._v(" Aktuálne otvorená ")]) : _vm._e()]), _c('div', {
      staticClass: "light-text"
    }, [_c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(_vm.getMortgageAmount(mortgage)) + " EUR")]), _vm._v(" " + _vm._s(_vm.getChoicesFromFormByKey("stage", mortgage.stage)) + " od " + _vm._s(_vm.getDate(mortgage.modified)) + " ")])])]);
  }), _c('div', {
    staticClass: "primary d-flex justify-content-between popupSection"
  }, [_c('span', {
    staticClass: "text-small bl-color pointer"
  }, [_vm._v("POZNÁMKY KLIENTA")]), _c('client-note-handler', {
    attrs: {
      "client": _vm.clientData
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column-reverse"
  }, _vm._l(_vm.clientData.client_profile.client_notes, function (note) {
    return _c('div', {
      key: note.id,
      staticClass: "popup-block"
    }, [_c('div', {
      staticClass: "bold primary"
    }, [_vm._v(" zo dňa " + _vm._s(_vm.getDate(note.created)) + " ")]), _c('span', {
      staticClass: "overflow-wrap-break"
    }, [_vm._v(_vm._s(note.note))])]);
  }), 0)] : _vm._e()], 2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "client-flow-eyebrow"
  }, [_vm._v("Práca s klientom")]), _c('div', {
    staticClass: "client-flow-title"
  }, [_vm._v("Postup úloh")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Naplánovať online konzultáciu")]), _c('small', [_vm._v("Otvoriť kalendár, vybrať termín a poslať klientovi pozvánku")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "quick-processed-deal__copy"
  }, [_c('strong', [_vm._v("Rýchlo zaevidovať obchod")]), _c('small', [_vm._v("Už načerpaná hypotéka bez prepočtu a celého procesu")])]);

}]

export { render, staticRenderFns }